import * as React from 'react';
import { PublicPageProvider } from '../../../_contexts/PublicPageContext';
import { PublicLearningPageWrapper } from '../../../../designSystem/layouts/pageWrappers/PublicLearningPageWrapper';
import { LearningModuleContent } from '../../../_components/learning/LearningModuleContent';

export function LearningModulePublicPage (): JSX.Element
{
    return (
        <PublicPageProvider partner='Joblife'>
            <PublicLearningPageWrapper>
                <LearningModuleContent isPublic />
            </PublicLearningPageWrapper>
        </PublicPageProvider>
    );
}